import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  Batch,
  Team,
  User,
  Campus,
  ApiService,
  LocalStorageService,
  ROLES,
  SnackbarService,
 } from '../../../shared';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-me-page',
  templateUrl: './me-page.component.html',
})
export class MePageComponent implements OnInit {
  title: string = 'me';
  subtitle: string = 'thranduil';
  user: User;
  team: Team;
  batch: Batch;
  campus: Campus;
  currentClusterName$: Observable<string>;

  constructor(
    private apiService: ApiService,
    private storageService: LocalStorageService,
    private snackBarService: SnackbarService,
  ) { }

  ngOnInit() {
    this.getMeAndBatch();
    this.getMyTeam();
    this.getMyCampus();
    this.currentClusterName$ = this.getCurrentClusterName();
  }
  
  getMeAndBatch() {
    this.apiService.getMe()
      .pipe(
        switchMap(user => {
          this.user = user;
          this.subtitle = `${user.firstName} ${user.lastName}`;
          if (this.user.role !== ROLES.TEACHER) {
            return this.apiService.getMyBatch()
          }
        })
      )
      .subscribe(batch => this.batch = batch);
  }

  getMyTeam() {
    this.apiService.getMyTeam()
      .subscribe(team => this.team = team);
  }

  getMyCampus() {
    this.apiService.getMyCampus()
      .subscribe(campus => this.campus = campus);
  }

  getCurrentClusterName(): Observable<string> {
    return this.storageService.getClusterName();
  }

  handleSwitchCluster(updatedClusterName: string) {
    this.storageService.setClusterName(updatedClusterName);
    this.currentClusterName$ = this.getCurrentClusterName();
  }

  handleUpdatePassword(freshPassword: string) {
    this.apiService.updatePassword(this.user, this.batch, this.team, this.campus, freshPassword)
      .subscribe(r => this.snackBarService.showSuccess('password has been successfully updated'));
  }
}



// WEBPACK FOOTER //
// ./src/app/me/pages/me-page/me-page.component.ts